<template>
  <div class="self-induction-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>E = -L · (ΔI/Δt)$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 混合仿真：两个灯泡对比 -->
      <div class="canvas-item simulation">
         <svg width="100%" height="220" viewBox="0 0 400 220">
            <!-- 电路背景 -->
            <path d="M 50 110 H 100 M 300 110 H 350 M 100 60 H 300 M 100 160 H 300" fill="none" stroke="#333" stroke-width="2" />
            
            <!-- 纯电阻之路 -->
            <rect x="180" y="50" width="40" height="20" fill="none" stroke="#2ed573" />
            <circle cx="280" cy="60" r="10" :fill="getBulbColor(i1)" stroke="#888" />
            <text x="120" y="55" fill="#888" font-size="9">纯电阻 R</text>

            <!-- 电感之路 -->
            <path d="M 170 160 Q 180 140 190 160 Q 200 180 210 160 Q 220 140 230 160" fill="none" stroke="#00d2ff" stroke-width="3" />
            <circle cx="280" cy="160" r="10" :fill="getBulbColor(i2)" stroke="#888" />
            <text x="120" y="155" fill="#888" font-size="9">自感线圈 L</text>

            <!-- 开关 -->
            <g :transform="`translate(50, 110) rotate(${switchClosed ? 0 : -30})`" style="cursor: pointer" @click="toggleSwitch">
               <line x1="0" y1="0" x2="30" y2="0" stroke="#ffd700" stroke-width="4" />
            </g>
         </svg>

         <div class="hud-top">
            <div class="stat">
               <label>电感系数 L</label>
               <span class="val">{{ inductance }} H</span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <div class="col-full">
                  <label>电感线圈感应本领 (L)</label>
                  <el-slider v-model="inductance" :min="1" :max="50" size="mini"></el-slider>
               </div>
            </div>
            <div class="row center">
               <el-button type="primary" size="mini" @click="toggleSwitch">{{ switchClosed ? '断开开关' : '闭合开关' }}</el-button>
            </div>
         </div>

         <div class="law-hint">
            <p><strong>物理现象：</strong>闭合开关瞬间，由于<strong>自感电动势</strong>阻碍电流增加，电感支路的灯泡会<strong>缓慢亮起</strong>；断开瞬间则会产生极高电压阻碍电流消失。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelfInductionViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      inductance: 10,
      switchClosed: false,
      i1: 0, // Current in R branch
      i2: 0, // Current in L branch
      running: true
    }
  },
  methods: {
    toggleSwitch() {
       this.switchClosed = !this.switchClosed;
    },
    getBulbColor(i) {
       return `rgba(255, 215, 0, ${i})`;
    },
    animate() {
       if (!this.running) return;
       
       const target = this.switchClosed ? 1 : 0;
       
       // Branch 1: R (Almost instantaneous)
       this.i1 = this.i1 * 0.8 + target * 0.2;
       
       // Branch 2: L (Delayed by inductance)
       const delay = 1 - (this.inductance / 100); // eslint-disable-line no-unused-vars
       const factor = 0.05 * (10 / this.inductance);
       this.i2 = this.i2 * (1 - factor) + target * factor;

       requestAnimationFrame(this.animate);
    }
  },
  mounted() { this.animate(); },
  beforeDestroy() { this.running = false; }
}
</script>

<style scoped lang="scss">
.self-induction-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #00d2ff; background: rgba(0,210,255,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; right: 15px; .val { color: #ffd700; font-family: monospace; } }
}
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row { margin-bottom: 10px; &.center { text-align: center; } label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } } }
.law-hint { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
